import { SubscriptionsContainer } from '@/modules/Subscriptions';

const SubscriptionsList = (): JSX.Element => <SubscriptionsContainer />;

export default SubscriptionsList;
